import { Icon } from "./Icon.js";

/** An uploaded image with its remove control overlaid on the top-right corner. */
export function RemovableImage({
  src, alt, className, imgTestId, removeLabel, onRemove, removeTestId,
}: {
  src?: string;
  alt: string;
  className?: string;
  imgTestId?: string;
  removeLabel: string;
  onRemove: () => void;
  removeTestId?: string;
}) {
  return (
    <div className="removable-image">
      {src && <img className={className} src={src} alt={alt} data-testid={imgTestId} />}
      <button
        type="button"
        className="btn btn--sm btn--icon removable-image__remove"
        onClick={onRemove}
        aria-label={removeLabel}
        title={removeLabel}
        data-testid={removeTestId}
      >
        <Icon name="close" size={16} />
      </button>
    </div>
  );
}
